/**
 * Bọc input kèm đơn vị (m², tỷ...) hiển thị ở suffix bên phải.
 */
export const InputWithUnit = ({ unit, children }) => (
  <div className="input-with-unit">
    <div className="input-with-unit-field">{children}</div>
    <span className="input-with-unit-suffix" aria-hidden="true">
      {unit}
    </span>
  </div>
);
